// Decodifica só o payload do JWT (sem verificar assinatura — isso já foi feito pelo
// backend; aqui é só leitura de claim no cliente pra gate de UI, a autorização de
// verdade sempre acontece de novo no WootDash.Api via RequirePermission).
export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const part = token.split('.')[1]
    if (!part) return null
    const base64 = part.replace(/-/g, '+').replace(/_/g, '/').padEnd(part.length + (4 - (part.length % 4)) % 4, '=')
    return JSON.parse(atob(base64))
  } catch {
    return null
  }
}

// O WootDash emite uma claim "perm" por chave de permissão do agente (ver
// PermissionEndpointExtensions.cs) — vira array quando há mais de uma (o caso comum).
export function decodeJwtPermissions(token: string): string[] {
  const payload = decodeJwtPayload(token)
  const perm = payload?.perm
  if (Array.isArray(perm)) return perm as string[]
  if (typeof perm === 'string') return [perm]
  return []
}

// Claim "sid" — id da AgentSession criada no login (ver LoginCommandHandler/
// JwtTokenGenerator). É o mesmo id que GET /sessoes lista, então dá pra destacar
// "esta sessão" na tela de Meu Perfil sem precisar de um endpoint dedicado.
export function decodeJwtSessionId(token: string): string | null {
  const payload = decodeJwtPayload(token)
  const sid = payload?.sid
  return typeof sid === 'string' ? sid : null
}
